import { useCallback, useState } from 'react'

export type PasswordVisibility = {
  showPassword: boolean
  inputType: 'text' | 'password'
  toggleShowPassword: () => void
}

export const usePasswordVisibility = (): PasswordVisibility => {
  const [showPassword, setShowPassword] = useState<boolean>(false)
  const toggleShowPassword = useCallback(() => {
    setShowPassword(prev => !prev)
  }, [])
  return {
    showPassword,
    inputType: showPassword ? 'text' : 'password',
    toggleShowPassword,
  }
}
